import api from '../http';

export default class PartDBService {
    static async table() {
        return api.get('/part-db/table');
    }

    static async projects(filter) {
        return api.get('/part-db/projects', { params: { ...filter, offset: 0, limit: 100 } });
    }

    static async addProject(portalId, PartDbId, hwVersion) {
        return api.put('/part-db/projects', { pt_id: portalId, pd_id: PartDbId, hw: hwVersion });
    }

    static async editProject(portalId, PartDbId, hwVersion) {
        return api.post('/part-db/projects', { pt_id: portalId, pd_id: PartDbId, hw: hwVersion });
    }

    static async remove(portalId, PartDbId) {
        return api.delete(`/part-db/projects/${portalId}/${PartDbId}`);
    }

    static async partProject(partDbId) {
        return api.get(`/part-db/projects/${partDbId}`);
    }
    static async projectInfo(partDbId) {
        return api.get(`/part-db/projects/info/${partDbId}`);
    }
}
